export enum TenantType {
    SYSTEM = 'SYSTEM',
    PROSPECT = 'PROSPECT',
    TRIAL = 'TRIAL',
    SUBSCRIBED = 'SUBSCRIBED'
}
export enum LoginOption {
    LoginByPhone = 'LoginByPhone',
    LoginByEmail = 'LoginByEmail'
}

export enum UserRoles {
    SYSTEM_SUPER_ADMIN = 'SYSTEM_SUPER_ADMIN',
    SYSTEM_ADMIN = 'SYSTEM_ADMIN',
    SYSTEM_USER = 'SYSTEM_USER',
    TENANT_ADMIN = 'TENANT_ADMIN',
    TENANT_MANAGER = 'TENANT_MANAGER',
    TENANT_STAFF = 'TENANT_STAFF'

}

export enum TenantSubscriptionPlanStatus {

    PAYMENT_PENDING = 'PAYMENT_PENDING',
    PAID = 'PAID',
    ACTIVATED = 'ACTIVATED',
    DEACTIVATED = 'DEACTIVATED',
}
export enum JobAllocationType {

    JOB = 'JOB',
    BLOCK = 'BLOCK'
}